<template lang="pug">
  .lista-solicitud-vacaciones.contenedor-interno
    .title
      span Reporte de cursos virtuales
    transition-group.contenedor-box-transition(name="fade-smooth-two", tag="div")
      .filtros-container(key="filtros-container")
        transition-group.contenedor-box-transition(name="fade-smooth-two", tag="div")
          .title-filtro(@click="mostrarFiltros = !mostrarFiltros",:class="{'hide-box-shadow': !mostrarFiltros}" , key="title-filtro")
            h2.text filtros
            .caret
              span.icon
                i.fa.fa-caret-down(v-if="mostrarFiltros")
                i.fa.fa-caret-up(v-else)
          .filtros(v-if="mostrarFiltros", key="filtros")
            .columns.is-multiline.display-flex
              .column
                .filtro
                  .codigo-empleado
                    .control.title-singular
                      p Alumno
                      .input-container
                        input.input(
                          type="number",
                          v-model="filtros.codigoEmpleado"
                          @focus="mostrarBusquedaEmpleado = true"
                        )
                        span.icon.cursor-pointer.margin-left-5(@click="mostrarBusquedaEmpleado = true")
                          i.fa.fa-search
                        .erase-data(@click="filtros.codigoEmpleado = ''")
                          .icon
                            .fa.fa-times
                    transition(name="fade-quick")
                      .pop-over(
                          v-if="mostrarBusquedaEmpleado"
                        )
                          lookup-small-empleado(
                            @selected="seleccionarEmpleado"
                            @close="mostrarBusquedaEmpleado = false"
                            :codigo="filtros.codigoEmpleado"
                          )
              .column
                .filtro
                  .title-singular
                    p Curso
                  .select.display-flex
                    select.flex-1(v-model='filtros.idCurso' @change="changeFiltroCurso" :disabled="isLoadingCursos")
                      option(:value="''") Todos
                      option(v-for="o in cursos", :value="o.id") {{ o.titulo | truncateText(20) }}
              .column
                .filtro
                  .title-singular
                    p Clase
                  .select.display-flex
                    select.flex-1(v-model='filtros.idClase' @change="changeFiltro" :disabled="isLoadingClases || isLoadingCursos")
                      option(:value="''") Todos
                      option(v-for="o in clases", :value="o.id") {{ o.titulo | truncateText(20) }}
              .column
                .filtro
                  .title-singular
                    p {{ 'Activo(curso)' }}
                  .select.display-flex
                    select.flex-1(v-model='filtros.activoCurso' @change="changeFiltro")
                      option(:value="''") Todos
                      option(:value="'1'") Sí
                      option(:value="'0'") No
              .column
                .filtro
                  .title-singular
                    p {{ 'Activo(clase)' }}
                  .select.display-flex
                    select.flex-1(v-model='filtros.activoClase' @change="changeFiltro")
                      option(:value="''") Todos
                      option(:value="'1'") Sí
                      option(:value="'0'") No
              .column
                .filtro
                  .title-singular
                    p Desde termino clase
                    .input-container
                      input.input(
                        type="date",
                        v-model="filtros.desdeFechaTermino"
                      )
              .column
                .filtro
                  .title-singular
                    p Hasta termino clase
                    .input-container
                      input.input(
                        type="date",
                        v-model="filtros.hastaFechaTermino"
                      )
              .column
                .filtro
                  .title-singular
                    p Desde inicio curso
                    .input-container
                      input.input(
                        type="date",
                        v-model="filtros.desdeInicioCurso"
                      )
              .column
                .filtro
                  .title-singular
                    p Hasta inicio curso
                    .input-container
                      input.input(
                        type="date",
                        v-model="filtros.hastaInicioCurso"
                      )
              .column
                .filtro
                  .title-singular
                    p Desde ver curso
                    .input-container
                      input.input(
                        type="date",
                        v-model="filtros.desdeVerCurso"
                      )
              .column
                .filtro
                  .title-singular
                    p Hasta ver curso
                    .input-container
                      input.input(
                        type="date",
                        v-model="filtros.hastaVerCurso"
                      )
              .column
                .filtro
                  .title-singular
                    p Estado del curso del alumno
                  .select.display-flex
                    select.flex-1(v-model='filtros.estadoCursoAlumno' @change="changeFiltro")
                      option(:value="''") Todos
                      option(:value="'1'") Terminado
                      option(:value="'2'") En progreso
                      option(:value="'0'") Sin empezar
              .column
                .filtro
                  .title-singular
                    p Estado de la clase del alumno
                  .select.display-flex
                    select.flex-1(v-model='filtros.estadoClaseAlumno' @change="changeFiltro")
                      option(:value="''") Todos
                      option(:value="'0'") Sin empezar
                      option(:value="'1'") Terminado

          .boton-container(key="boton-container")
            button.button.m-5(@click="fetch")
              span.icon.is-small
                i.fa.fa-refresh.fa-fw.fa-lg
              span Refrescar
            button.button.m-5(@click="limpiarFiltros")
              span.icon.is-small
                i.fa.fa-trash.fa-fw.fa-lg
              span Limpiar
      .body(key="body")
        .information
          transition-group.contenedor-data(
            v-infinite-scroll="fetchByScroll"
            infinite-scroll-disabled="disabledScrollExecute"
            infinite-scroll-distance="2"
            name="fade-smooth-two"
            tag="div"
          )
            table.table.is-striped.is-bordered(
              v-if="lista.length !== 0"
              key="lista"
            )
              thead
                th Curso
                th Clase
                th Alumno
              tbody(
                name="table-row"
                is="transition-group"
              )
                tr.row-table(
                  v-for="(o, index) in lista"
                  :key="index"
                )
                  td(:class="{'is-close': !o.activoCurso}")
                    span.hint--top(:aria-label="'id: ' + o.idCurso") {{ o.tituloCurso }}
                      .chip.ver-curso(v-if="o.fechaVerCurso")
                        span.has-text-bold Visto {{ o.fechaVerCurso | formatDateHour }}
                      .chip.iniciado(v-if="o.fechaInicioAlumno")
                        span.has-text-bold Iniciado {{ o.fechaInicioAlumno | formatDateHour }}
                      .chip.terminado(v-if="o.fechaTerminoCursoAlumno")
                        span.has-text-bold Terminado {{ o.fechaTerminoCursoAlumno | formatDateHour }}
                      // .ver-curso
                        span.has-text-bold En progreso 09/10/2024
                  td(:class="{'is-close': !o.activoClase}")
                    span.hint--top(:aria-label="'id: ' + o.idClase") {{ o.tituloClase }}
                      .chip.terminado(v-if="o.fechaTerminoClaseAlumno")
                        span.has-text-bold Terminado {{ o.fechaTerminoClaseAlumno | formatDateHour }}
                  td
                    .td-wrapper
                      span.hint--top(:aria-label="'Empleado: ' + o.dniEmpleado") {{ o.nombreEmpleado }}
                      //- template(v-if="o.rutaSubido")
                      //-   .seen
                      //-     span.has-text-bold Subido
                      //-     span.icon
                      //-       i.fa.fa-check.fs-12
                      //-   .dates-wrapper
                      //-     span.has-text-bold Fecha Subido:&nbsp;
                      //-     span {{ o.fechaSubidoArchivoEmpleado }}

        .is-loading(v-if="isLoading")
          .icon
            i.fa.fa-spinner.fa-spin
        .message.is-warning(v-if="lista.length === 0 && !isLoading")
          .message-body
            span.has-text-bold No existe información con los filtros definidos
</template>

<script>
import LookupSmallEmpleado from './Component_Lookup_Small_Empleado'
import { apiGet, notify } from '../util/general'
import ConfirmarAccionOverlayComponent from '../components/Component_Confirmar_Accion_Overlay'
export default {
  name: 'reporte_contratos_component',
  data () {
    return {
      lista                     : [],
      isLoading                 : false,
      mostrarBusquedaEmpleado   : false,
      mostrarFiltros            : true,
      filtros                   :{
        idCurso : '',
        idClase : '',
        codigoEmpleado: '',
        estadoClaseAlumno : '',
        estadoCursoAlumno : '',
        desdeFechaTermino : '',
        hastaFechaTermino : '',
        desdeInicioCurso  : '',
        hastaInicioCurso  : '',
        desdeVerCurso     : '',
        hastaVerCurso     : '',
        activoCurso : '1',
        activoClase : '1'
      },
      cursos: [],
      clases: [],
      isProcessing: false,
      disabledScrollExecute: true,
      isScroll               : false,
      skip                   : 0,
      noMore                 : false,
      isSaving:false,
      fetchClaseEP:'',
      isLoadingCursos: false,
      isLoadingClases: false,
      disable:true
    }
  },
  components: {
    LookupSmallEmpleado,
    'confirmar-accion-overlay': ConfirmarAccionOverlayComponent
  },
  created () {
    this.fetch()
    this.fetchCursos()
    this.fetchClases()
  },
  methods: {
    changeFiltro () {
      this.fetch();
    },
    changeFiltroCurso () {
      if (this.filtros.idCurso) {
        this.fetchClaseEP = `/curso/gestion/${this.filtros.idCurso}/clase`
        this.fetchClases()
        .then(() => this.fetch())
        return
      }
      this.fetchClaseEP = ''
      this.fetch()
      this.fetchClases()
    },
    fetchByScroll () {
      var vm = this
      vm.isScroll = true
      vm.fetch()
    },
    fetchCursos () {
      var vm = this
      if (vm.isLoadingCursos) return
      vm.isLoadingCursos = true
      apiGet(vm, '/curso/', {}, function (data) {
        vm.cursos = data.lista
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoadingCursos = false
      })
    },
    fetchClases () {
      return new Promise((resolve, reject) => {
        var vm = this
        if (vm.isLoadingClases) return
        vm.isLoadingClases = true
        apiGet(vm, vm.fetchClaseEP || '/curso/gestion/0/clase', {skipIdCurso:true}, function (data) {
          vm.clases = data.lista
          if (vm.filtros.idClase) {
            const element = data.lista.find(o => o.id === vm.filtros.idClase)
            vm.filtros.idClase = element ? element.id : ''
          }
          resolve(null)
        }, function (error) {
          notify(vm, 'error', 'Error', error.message)
          reject(error)
        }, function () {
          vm.isLoadingClases = false
        })
      })
    },
    fetch () {
      var vm = this
      vm.isLoading = true
      var obj = { ...vm.filtros }
      vm.disabledScrollExecute = true
      vm.noMore = false
      if (!vm.isScroll) {
        vm.lista = []
        vm.skip = 0
      }
      obj.skip = vm.skip
      apiGet(vm, '/curso/reporte/curso-clase-alumno', obj, function (data) {
        for (let index = 0; index < data.lista.length; index++) {
          const element = data.lista[index];
          vm.lista.push(element)
        }
        if (data.noMore) {
          vm.noMore = true
          vm.disabledScrollExecute = true
        } else {
          vm.skip += data.lista.length
          vm.disabledScrollExecute = false
        }
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
        vm.isScroll = false
      })
    },
    seleccionarEmpleado (o) {
      this.filtros.codigoEmpleado = o.codigo
    },
    limpiarFiltros () {
      this.filtros = {
        idCurso : '',
        idClase : '',
        codigoEmpleado: '',
        estadoClaseAlumno : '',
        estadoCursoAlumno : '',
        desdeFechaTermino : '',
        hastaFechaTermino : '',
        desdeInicioCurso  : '',
        hastaInicioCurso  : '',
        desdeVerCurso     : '',
        hastaVerCurso     : '',
        activoCurso : '1',
        activoClase : '1'
      }
      this.fetch()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .is-close
    background-color #ffd6d6 !important
  .chip
    padding: 0px 4px;
    margin-top: 3px;
    border-radius: 4px;
    &.terminado
      background-color: #cf9e9e !important;
      color: #fff;
    &.sin-empezar
      background-color: #f9f9f9 !important;
    &.ver-curso
      border:1px solid #ccc;
    &.iniciado
      background-color: #94b3e9 !important;
    &.en-progreso
      background-color: #3dde7b !important;

  .fs-12
    font-size 12px
  .contenedor-interno
    .close
      position absolute
      top 3px
      right 3px
      float right
      cursor pointer
      i
        font-size 16px

    .title
      font-size 16px
      span
        font-weight bold
        text-transform uppercase

  th
    text-align center

  .row-table
    transition all 0.3s ease
    &.is-close
      background-color #ffd6d6 !important


  .table-row-enter, .table-row-leave-active {
    opacity: 0
    height 0
  }

  .pop-over
    background: #fff;
    border-radius: 3px;
    border: 1px solid #d6dadc;
    border-bottom-color: #c4c9cc;
    -webkit-box-shadow: 0 1px 6px rgba(0,0,0,.15);
    box-shadow: 0 1px 6px rgba(0,0,0,.15);
    position: absolute;
    min-width: 300px
    width: 100%;
    z-index: 70;
    top 0

  .position-relative
    position relative

  .codigo-empleado
    position relative
    .control
      .input-container
        display flex
        align-items center
        .input
          flex 1
          width 100px
        .erase-data
          cursor pointer
          margin-left 5px

  .filtros-container
    padding-bottom 10px
    border-bottom 1px solid #ccc
    .title-filtro
      display flex
      text-align left
      padding 10px
      margin-bottom 10px
      border-bottom 1px solid #ccc
      .text
        text-transform uppercase
        flex 1
      .caret
        cursor pointer

    .filtros
      margin-bottom 10px
      text-align left
      display flex
      align-items: flex-start;


      .filtro
        // width 100%
        display inline-block
        border 1px solid #cccccc
        background-color #f9f9f9
        padding 5px
        margin 5px
        border-radius 3px
        flex 1
        .title-singular
          text-align left
          font-weight bold
          user-select: none
        .abierto-cerrado-container
          display flex
          .option
            padding 4px
            border 1px solid #565cde
            color #565cde
            cursor pointer
            transition all 0.3s ease
            height 31.5px

            &.selected
              background-color: #565cde;
              color: #fff;

        .list-container
          padding 0px 10px 0px 10px
          .option
            user-select: none
            cursor pointer
            &.selected
              color #565cde
              font-weight bold

  .boton-container
    button
      margin-left 5px

  .contenedor-acciones
    display flex
    flex-wrap: wrap;
    .button
      flex 1
      margin 3px 5px

  .is-loading
    margin-top 10px

  .button.is-loading
    margin-top 0px

  .information
    padding-top 10px

  td
    vertical-align: middle;

  is-close
    background-color: #ffd6d6 !important;

  .text-align-center
    text-align center

  .contenedor-frame
    position fixed
    background-color #ccc
    left 1
    top: 0px;
    left: 0px;
    width: 100%;
    height 100vh;
    padding 20px
    transition all 0.5s ease
    z-index: 9999

    .titulo
      display flex
      align-items center
      .texto
        flex 1
        text-align left
        font-size 25px
      .button
        margin-bottom 10px

    iframe
      width 100%
      height calc(100% - 30px);

  .card-footer-item:not(:last-child)
    border-right: 1px solid #dbdbdb
  .info-box-button
    border-radius 0
    border        0px

  .show-break-1
    display none
  .wrapper
    display flex
    justify-content left
    align-items left
    flex-direction column

  @media (max-width: 650px)
    .show-break-1
      display initial
    .hide-break-1
      display none
    .table
      font-size 12px
      td
        text-align: center
        vertical-align: middle
      .td-wrapper
        display flex
        justify-content: center
        align-items: center
        flex-direction: column

        .dates-wrapper
          display: flex
          flex-direction: column
        .seen
          background-color: #94b3e9;
          color: #fff23;
          padding: 0px 4px;
          margin-top: 3px;
          border-radius: 4px;
  @media (max-width: 520px)
    .boton-container
      .margin-button-top
        margin-top 5px
</style>



// WEBPACK FOOTER //
// c_reporte_cursos_virtuales.vue?42635857